import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import keycode from 'keycode';
import Table, {
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
} from 'material-ui/Table';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';
import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import Tooltip from 'material-ui/Tooltip';
import DeleteIcon from 'material-ui-icons/Delete';
import { SpeakerNotes } from 'material-ui-icons'
import Menu, { MenuItem } from 'material-ui/Menu';
import { withRouter } from "react-router-dom";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment'

import * as userdetails from '../../../actions/userdetails';

import SortableUser from "./sortableuser";

import { arrayMove, SortableContainer } from 'react-sortable-hoc';

const Userrow = SortableContainer(({ users }) => {
    return (
        <TableBody>
            {users.map((user, index) => (
                <SortableUser key={index} index={index} user={user} />
            ))}
        </TableBody>
    );
});

const columnData = [
    { id: 'id', numeric: false, disablePadding: false, label: 'ReOrder', isAdminOnly: false },
    { id: 'userId', numeric: false, disablePadding: true, label: 'User Id', isAdminOnly: false },
    { id: 'userName', numeric: false, disablePadding: true, label: 'User Name', isAdminOnly: false },
    { id: 'emailId', numeric: false, disablePadding: true, label: 'Email', isAdminOnly: false },
];

class DataTableHead extends React.Component {
    render() {
        const { order, orderBy, numSelected, rowCount, loggedinUserRole_id } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {columnData.map(column => {
                        return (
                            (column.isAdminOnly && loggedinUserRole_id != "2") ? null :
                                <TableCell
                                    key={column.id}
                                    numeric={column.numeric}
                                    padding={column.disablePadding ? 'none' : 'checkbox'}
                                >
                                    {column.label}
                                </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

class DataTable extends React.Component {

    constructor() {
        super();
        this.state = {
            setValue: false,
            isSortUser: false,
            data: [],
        };
    }

    componentDidMount() {
        this.state = {
            setValue: false,
            data: [],
        };
        this.props.actions.getUserOrderDetailsList();
    }
    onSortEnd = ({ oldIndex, newIndex, collection }) => {
        if (oldIndex != newIndex) {
            // console.log(oldIndex, newIndex, collection)
            let id = this.state.data[oldIndex].id

            this.setState({
                data: arrayMove(this.state.data, oldIndex, newIndex),
            });
            this.props.actions.updateUserOrder(id, newIndex + 1,oldIndex+1);
        }
    };
    render() {
        if (!this.state.setValue && this.props.UserdetailsList && this.props.UserdetailsList[0] && this.props.UserdetailsList[0].orderLevel >= 0) {
            this.state.setValue = true;
            this.state.data = this.props.UserdetailsList
            // console.log('data', this.state.data)
        }
        // console.log('props.UserdetailsList', this.props.UserdetailsList)
        // console.log('data', this.state.data)
        return (
            <Paper>
                <div className="flex-auto">
                    <div className="table-responsive-material">
                        <Table className="">
                            <DataTableHead
                                loggedinUserRole_id={this.props.loggedinUserRole_id}
                            />
                            {/* {console.log('data', this.state.data)} */}
                            {!this.state.data ?
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={4}/>
                                    </TableRow>
                                </TableBody>
                                :
                                <Userrow users={this.state.data} onSortEnd={this.onSortEnd} useDragHandle={true} useDragHandle={true} />
                            }
                        </Table>
                    </div>
                </div>
            </Paper>
        );
    }
}

function mapStateToProps(state) {
    return state;
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(userdetails, dispatch)
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DataTable));


// WEBPACK FOOTER //
// ./app/userdetails/userorder/datatable.js